<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component view-competence-comment" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0" v-if="item.Comment != null && item.Comment != ''">
                        <div class="row">
                            <div class="col">
                                <b>Kommentar:</b>
                                <div v-html="item.Comment"></div>

                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <b>Påminnelsedatum:</b>
                                <div v-html="item.ReminderDate"></div>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid p-0" v-if="item.Comment == null || item.Comment == ''">
                        <div class="row">
                            <div class="col">
                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Kommentar" v-model="addedComment" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field v-bind:disabled="disabled" bg-color="white" type="date" label="Yrkets startdatum" v-model="addedDate" variant="outlined"></v-text-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1" v-if="item.Comment != null && item.Comment != ''"
                           variant="text"
                           @click="done">
                        Klar
                    </v-btn>
                    <v-btn color="blue-darken-1" v-if="item.Comment == null || item.Comment == ''"
                           variant="text"
                           @click="add">
                        Lägg till
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import WageService from "../../../Services/WageService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'view-competence-comment',
        props: {

        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async add() {
                await WageService.updateEmployeeCompetency(this.employeeId, this.item.PositionBlockId, this.item.Val, this.addedComment, this.addedDate);
                this.$emit("updated");
                this.close();
            },
            async done() {
                if (confirm("Är du säker på att du vill ta bort kommentaren?")){
                    await WageService.updateEmployeeCompetency(this.employeeId, this.item.PositionBlockId, this.item.Val, null, null);
                    this.$emit("updated");
                    this.close();
                }
            },
            close() {
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            open(item, employeeId) {
                this.item = item;
                this.employeeId = employeeId;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
        },
        data() {
            return {
                addedCommen: null,
                addedDate:null,
                employeeId: null,
                item: {
                    Comment: "",
                    ReminderDate: "",
                    PositionBlockId: null,
                    Val: null
                },
                dialogueVisible: false,
                thisModal: {},
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) { }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
